var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"0 auto"},style:({ width: _vm.width + 'px', height: _vm.height + 'px' })},[_c('div',{attrs:{"id":"canvas"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }